import React, { useEffect, useState } from "react"
import { generalStyles as gs } from "../../styles/styles"
import EntiteIdentiteV2 from "../entite/EntiteIdentiteV2"
import EntiteAdressesV2 from "../entite/EntiteAdressesV2"
import EntiteTarificationV2 from "../entite/EntiteTarificationV2"
import RH from "./RH"
import FlotteV2 from "./FlotteV2"
import EntitesV2 from "./EntitesV2"
import MoyensPaiementV2 from "./MoyensPaiementV2"
import AdressesV2 from "./AdressesV2"
import PointsInteretV2 from "./PointsInteretV2"
import SecteursV2 from "./SecteursV2"
import MarquesV2 from "./MarquesV2"
import TachesV2 from "./TachesV2"
import DiagnostiquesV2 from "./DiagnostiquesV2"
import TarifsPoliceV2 from "./TarifsPoliceV2"
import TarifsPrivesV2 from "./TarifsPrivesV2"
import EmailTemplatesV2 from "./EmailTemplatesV2"
import NotificationsConfigV2 from "./NotificationsConfigV2"
import { useRights } from "../../../hooks/rights"

// Un droit par onglet (lignes « Config : … » de la matrice Excel). La page
// s'ouvre dès qu'un onglet est autorisé — cf. le module DÉRIVÉ `configuration`
// côté serveur (backend/svp/access.py).
const TABS = [
	{ key: "identite", label: "Identité", right: "config_identite" },
	{ key: "vehicule", label: "Véhicule", right: "config_vehicules" },
	{ key: "entite", label: "Entité", right: "config_entites" },
	{ key: "rh", label: "RH", right: "config_rh" },
	{
		key: "paiements",
		label: "Moyens de paiement",
		right: "config_paiements",
	},
	{ key: "adresses", label: "Adresses", right: "config_adresses" },
	{
		key: "depannage",
		label: "Paramètres dépannage",
		right: "config_depannage",
	},
	{ key: "marques", label: "Marques / modèles", right: "config_marques" },
	{ key: "taches", label: "Tâches", right: "config_taches" },
	{ key: "emails", label: "Modèles d'e-mail", right: "config_emails" },
	{
		key: "notifications",
		label: "Notifications",
		right: "config_notifications",
	},
]

const styles = {
	actions: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: 22,
	},
}

// Onglet Dépannage : regroupe les référentiels du flux terrain en
// sous-onglets (mêmes pastilles que l'onglet Tâches).
const SOUS_TABS_DEPANNAGE = [
	{ key: "diagnostics", label: "Diagnostics assistance" },
	{ key: "secteurs", label: "Secteurs" },
	{ key: "poi", label: "Points d'intérêt" },
	{ key: "tarifsPolice", label: "Tarifs police" },
	// GE-66 : grille des dépannages privés.
	{ key: "tarifsPrives", label: "Tarifs privés" },
]

const DepannageTab = () => {
	const [sousTab, setSousTab] = useState("diagnostics")
	return (
		<>
			<div style={gs.sectionTabs}>
				{SOUS_TABS_DEPANNAGE.map((t) => (
					<button
						key={t.key}
						type="button"
						style={gs.sectionTab(sousTab === t.key)}
						onClick={() => setSousTab(t.key)}
					>
						{t.label}
					</button>
				))}
			</div>
			{sousTab === "diagnostics" && <DiagnostiquesV2 />}
			{sousTab === "secteurs" && <SecteursV2 />}
			{sousTab === "poi" && <PointsInteretV2 />}
			{sousTab === "tarifsPolice" && <TarifsPoliceV2 />}
			{sousTab === "tarifsPrives" && <TarifsPrivesV2 />}
		</>
	)
}

// Composes the reusable entity sections; owns only the tabs + save chrome.
const ConfigurationForm = ({
	entite,
	update,
	updateAdresse,
	addAdresse,
	onRequestSave,
	saving,
	saved,
	tab,
	setTab,
	updateTarification,
	updateExtraData,
}) => {
	const { hasRight } = useRights()
	const onglets = TABS.filter((t) => hasRight(t.right))

	// Retombe sur le premier onglet autorisé : « Identité » (l'onglet par
	// défaut) est boss-only, un admin arriverait sinon sur un écran vide.
	useEffect(() => {
		if (!onglets.length) return
		if (!onglets.some((t) => t.key === tab)) setTab(onglets[0].key)
	}, [onglets, tab, setTab])

	return (
		<>
			<div style={gs.segmented}>
				{onglets.map((t) => (
					<button
						key={t.key}
						type="button"
						style={gs.segment(tab === t.key)}
						onClick={() => setTab(t.key)}
					>
						{t.label}
					</button>
				))}
			</div>

			{tab === "identite" && (
				<>
					<EntiteIdentiteV2
						entite={entite}
						update={update}
						updateExtraData={updateExtraData}
					/>
					<div style={gs.mt18}>
						{/* Une seule adresse : parcs (dépôts) et ateliers sont des
						    POI (Paramètres dépannage › Points d'intérêt). */}
						<EntiteAdressesV2
							adresses={entite.adresses}
							updateAdresse={updateAdresse}
							addAdresse={addAdresse}
							max={1}
						/>
					</div>
					<div style={gs.mt18}>
						<EntiteTarificationV2
							entite={entite}
							updateTarification={updateTarification}
						/>
					</div>
				</>
			)}

			{tab === "vehicule" && <FlotteV2 />}

			{tab === "entite" && <EntitesV2 />}

			{tab === "rh" && <RH />}

			{tab === "paiements" && <MoyensPaiementV2 />}

			{tab === "adresses" && <AdressesV2 />}

			{tab === "depannage" && <DepannageTab />}

			{tab === "marques" && <MarquesV2 />}

			{tab === "taches" && <TachesV2 />}

			{tab === "emails" && <EmailTemplatesV2 />}

			{tab === "notifications" && <NotificationsConfigV2 />}

			{tab === "identite" && (
				<div style={styles.actions}>
					<button
						type="button"
						style={{
							...gs.btnPrimary,
							...((saving || saved) && {
								opacity: 0.5,
								cursor: "not-allowed",
							}),
						}}
						onClick={onRequestSave}
						disabled={saving || saved}
					>
						Enregistrer
					</button>
				</div>
			)}
		</>
	)
}

export default ConfigurationForm
